import r2wc from '@r2wc/react-to-web-component';
import React from 'react';
import BaseButton from '../components/BaseButton';

const Button = (props) => {
    const {slot, ...others} = props;
    return (
      <BaseButton {...others}>
      </BaseButton>
    );
}

const EmButton = r2wc(Button, {
  props: {
    classes:"string",
    href: "string",
    icon:"string",
    iconleft:"boolean",
    size: "string",
    slot: "string",
    target: "string",
    title: "string",
    type:"string",
    iconClassName: "string"
  },
});
customElements.define("em-button", EmButton);
